module.exports = __webpack_public_path__ + "img/fresh-chat.1977d9cc.png";